import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Plus, ExternalLink } from 'lucide-react';

const API = 'https://crm.ashbournesystems.ca/api';

const statusColors = {
  inquiry: '#C8941A', active: '#2d6a2d', complete: '#B85A22', cancelled: '#8b2020'
};

export default function Projects({ token }) {
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [filter, setFilter] = useState('all');
  const [form, setForm] = useState({ client_id: '', name: '', package_type: 'Business Website', status: 'inquiry', price: '', deposit_amount: '', deadline: '', github_repo_url: '', live_url: '', scope_description: '' });
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => {
    axios.get(`${API}/projects`, { headers }).then(r => setProjects(r.data)).catch(() => {});
    axios.get(`${API}/clients`, { headers }).then(r => setClients(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/projects`, form, { headers });
      toast.success('Project created');
      setShowForm(false);
      load();
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  const filtered = filter === 'all' ? projects : projects.filter(p => p.status === filter);

  const inputStyle = { width: '100%', padding: '0.65rem', background: '#0e0804', border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.82rem', outline: 'none', boxSizing: 'border-box', marginBottom: '0.75rem' };
  const labelStyle = { display: 'block', fontSize: '0.62rem', color: '#8a6840', letterSpacing: '0.1em', marginBottom: '4px' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#F5ECD7', marginBottom: '4px' }}>Projects</h1>
          <p style={{ color: '#8a6840', fontSize: '0.85rem' }}>{projects.filter(p => p.status === 'active').length} active</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.25rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold' }}>
          <Plus size={16} /> New Project
        </button>
      </div>

      {showForm && (
        <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '3px solid #B85A22', padding: '1.5rem', marginBottom: '2rem' }}>
          <h3 style={{ color: '#F5ECD7', marginBottom: '1.5rem', fontSize: '1rem' }}>New Project</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={labelStyle}>CLIENT *</label>
                <select style={inputStyle} value={form.client_id} onChange={e => setForm({...form, client_id: e.target.value})} required>
                  <option value="">Select client...</option>
                  {clients.map(c => <option key={c.id} value={c.id}>{c.business_name || c.name}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>PROJECT NAME *</label><input style={inputStyle} value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
              <div>
                <label style={labelStyle}>PACKAGE</label>
                <select style={inputStyle} value={form.package_type} onChange={e => setForm({...form, package_type: e.target.value})}>
                  <option>Starter Landing Page</option>
                  <option>Business Website</option>
                  <option>Custom</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>STATUS</label>
                <select style={inputStyle} value={form.status} onChange={e => setForm({...form, status: e.target.value})}>
                  <option value="inquiry">Inquiry</option>
                  <option value="active">Active</option>
                  <option value="complete">Complete</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              <div><label style={labelStyle}>PRICE (CAD)</label><input style={inputStyle} type="number" value={form.price} onChange={e => setForm({...form, price: e.target.value})} /></div>
              <div><label style={labelStyle}>DEPOSIT AMOUNT</label><input style={inputStyle} type="number" value={form.deposit_amount} onChange={e => setForm({...form, deposit_amount: e.target.value})} /></div>
              <div><label style={labelStyle}>DEADLINE</label><input style={inputStyle} type="date" value={form.deadline} onChange={e => setForm({...form, deadline: e.target.value})} /></div>
              <div><label style={labelStyle}>GITHUB REPO URL</label><input style={inputStyle} value={form.github_repo_url} onChange={e => setForm({...form, github_repo_url: e.target.value})} /></div>
            </div>
            <div><label style={labelStyle}>SCOPE / NOTES</label><textarea style={{...inputStyle, height: '80px', resize: 'vertical'}} value={form.scope_description} onChange={e => setForm({...form, scope_description: e.target.value})} /></div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button type="submit" style={{ background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: 'bold' }}>Save Project</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: 'transparent', border: '1px solid #2a1a0e', color: '#8a6840', padding: '0.75rem 1.5rem', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
        {['all', 'inquiry', 'active', 'complete', 'cancelled'].map(s => (
          <button key={s} onClick={() => setFilter(s)} style={{ padding: '0.4rem 1rem', background: filter === s ? '#B85A22' : 'transparent', border: `1px solid ${filter === s ? '#B85A22' : '#2a1a0e'}`, color: filter === s ? '#F5ECD7' : '#8a6840', cursor: 'pointer', fontSize: '0.72rem', textTransform: 'capitalize' }}>
            {s}
          </button>
        ))}
      </div>

      {/* Project list */}
      <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e' }}>
        {filtered.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: '#8a6840' }}>No projects found</div>
        ) : filtered.map((p, i) => (
          <div key={p.id} onClick={() => navigate(`/clients/${p.client_id}`)} style={{ padding: '1rem 1.5rem', borderBottom: i < filtered.length - 1 ? '1px solid #2a1a0e' : 'none', cursor: 'pointer' }}
            onMouseEnter={e => e.currentTarget.style.background = '#221208'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#F5ECD7', fontWeight: 'bold', fontSize: '0.9rem' }}>{p.name}</div>
                <div style={{ color: '#8a6840', fontSize: '0.75rem' }}>{p.business_name || p.client_name} · {p.package_type}</div>
                {p.deadline && <div style={{ color: '#8a6840', fontSize: '0.72rem' }}>Deadline: {new Date(p.deadline).toLocaleDateString()}</div>}
              </div>
              <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                {p.live_url && <a href={p.live_url} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ color: '#B85A22' }}><ExternalLink size={14} /></a>}
                <div>
                  <div style={{ color: '#C8941A', fontWeight: 'bold', fontSize: '0.9rem' }}>${p.price || 0}</div>
                  <span style={{ fontSize: '0.6rem', color: statusColors[p.status] || '#8a6840' }}>{p.status?.toUpperCase()}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}